<template>
  <div class="page">
    <div class="page__header">
      <div class="page__header-title">
        Tenant Information
        <div class="page__header-subtitle">See the tenant details here</div>
      </div>
      <div class="page__header-tools"></div>
    </div>
    <div class="page__body">
      <loader v-if="tenantDataLoading"></loader>
      <div v-else>
        <b-table
          striped
          hover
          :items="items"
          :fields="fields"
          thead-class="d-none"
          tbody-tr-class="row-class row-class-left"
        ></b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers(
  "admin/tenantInfoView"
);

export default {
  data: function () {
    return {
      fields: [
        { key: "key", label: "" },
        { key: "value", label: "" },
      ],
    };
  },

  mounted() {
    this.loadTenantInfo();
  },

  methods: {
    ...mapActions(["loadTenantInfo"]),
  },

  computed: {
    ...mapGetters(["tenantInfo", "tenantDataLoading"]),

    items() {
      let array = [];
      let data = this.tenantInfo;
      Object.keys(this.tenantInfo).map(function (key, index) {
        if (
          key == "Name" ||
          key == "Organization" ||
          key == "Domain" ||
          key == "Api Key" ||
          key == "Api Secret" ||
          key == "Registered On"
        )
          array.push({ key: key, value: data[key] });
      });
      return array;
    },
  },
};
</script>